// extracted by mini-css-extract-plugin
module.exports = {"axisName":"AxisName--axisName--2zpbs","dim":"AxisName--dim--ZEOaB"};